<script setup>
// Addendum §7 BackAction — restores the PRIOR state (filters, sort, page,
// scroll, selection). The mechanism is the URL: table state lives in query
// params, so "back" is free, deep links work, and a user can send a colleague
// the exact filtered view. Returning them to a bare unfiltered list after they
// drilled into row 240 is the default failure of this pattern — the URL is the
// fix.
//
// Pass `to` for an explicit destination (with its query string), or omit to use
// router history (which already carries the previous URL + its params).
import { useRouter } from 'vue-router'
import LIcon from '../base/Icon.vue'

const props = defineProps({
  label: { type: String, default: 'Back' },
  to: { type: [String, Object], default: null },
})
const router = useRouter()

function back() {
  if (props.to) router.push(props.to)
  else router.back()
}
</script>

<template>
  <button type="button" class="l-back" @click="back">
    <LIcon name="arrow-left" :size="13" />
    {{ label }}
  </button>
</template>

<style scoped>
.l-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-ui);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-2);
  min-height: var(--target-min);
  padding: 4px 8px 4px 4px;
  border-radius: var(--r-sm);
  background: none;
  border: 0;
  cursor: pointer;
}
.l-back:hover {
  color: var(--text);
  background: var(--surface-sunken);
}
</style>
